<template>
  <div></div>
</template>

<script>
export default {
  name: "SiteInfo",
  props: ["oemToken"],
  inject: ['updateSiteInfo'],
  data() {
    const root = process.env.VUE_APP_API;
    return {
      siteName: "REECH DATABASE",
      siteUrl: "",
      termsOfUseUrl: "https://reech.co.jp/term/",
      oemAPI: root + "/api/auth/oem",
    };
  },
  async mounted() {
    await this.fetchFromSiteName();
  },
  methods: {
    async fetchFromSiteName() {
      if (this.oemToken) {
        try {
          var params = new URLSearchParams();
          params.append("oem_token", this.oemToken);
          const response = await this.axios.post(this.oemAPI, params);
          
          if (response && response.data && response.data.oem) {
            if(response.data.oem.site_name && response.data.oem.site_name.trim() !== '') {
              this.siteName = response.data.oem.site_name;
            }
            if(response.data.oem.site_url && response.data.oem.site_url.trim() !== '') {
              this.siteUrl = response.data.oem.site_url;
            }
            if(response.data.oem.terms_of_use_url && response.data.oem.terms_of_use_url.trim() !== '') {
              this.termsOfUseUrl = response.data.oem.terms_of_use_url;
            }
            this.$emit('updateSiteInfo', {
              siteName: this.siteName, 
              siteUrl: this.siteUrl, 
              termsOfUseUrl: this.termsOfUseUrl
            });
          } else if (!(response && response.data && response.data.trial_register_url)) {
            this.$router.push("/404");
          }
        } catch (error) {
          console.error('タイトルの取得中にエラーが発生しました', error);
          this.$router.push("/404");
        }
      }
    },
  },
};
</script>